
import {Link} from "../models/Link";

export function isLink(arg: any): arg is Link {
  return arg.hasOwnProperty('href');
}
